
import { gsap } from "gsap";

const loaderTl = gsap.timeline({
  paused: true, paused: true, onComplete: function () {
    gsap.set('.main-wrapper', { clearProps: "all" });
  }
});

const set = () => {

  loaderTl
    .from('.top-bar__left > *, .top-bar__right > *', { autoAlpha: 0, y: 50, stagger: 0.2, duration: 1.4, ease: "quart.out" });

  // Se non ha già scrollato aggiungo anche questa animazione
  if (window.scrollY <= 50) {
    loaderTl.from('.home-intro__info > *', { autoAlpha: 0, y: 50, stagger: 0.2, duration: 1.4, ease: "quart.out" }, 0.8);
  }

  return loaderTl;
}

const play = (timeout = 100) => {

  document.querySelector('.loader').remove();
  setTimeout(() => {
    loaderTl.play();
  }, timeout);
}

export default { set, play };